import { NETWORK, StxChain } from '../types';

import { PROD_URL } from './constants';

export const stxToApiNetwork = (network: NETWORK) => {
  if (network === NETWORK.MAINNET) return StxChain.STX_MAINNET_CHAIN;

  return StxChain.STX_TESTNET_CHAIN;
};

export const getApiBaseUrl = () => {
  return PROD_URL;
};
